import React, { Component } from "react";
import { useNavigate, Navigate } from 'react-router-dom'
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import moment from 'moment'
import DashboardLayout from "../Theme/DashboardLayout/index.js";

import { Input, Button, Checkbox, Descriptions, Empty, Collapse, Typography, Divider, message } from "antd";
import { Toast, Confirm, Understood, Reason } from '../Notification/index.js';
import Widget from '../Theme/Widget/index.js';
import PageTitle from "../Theme/PageTitle/index.js";
import Spinner from '../Theme/Spinner/index.js';
import * as approvalActions from '../../redux/actions/approvalActions.js';
import AuthLogic from '../../AuthLogic/index.js';

import lodash from 'lodash';
const { cloneDeep, isEmpty } = lodash;

const { Panel } = Collapse;
const { Title } = Typography;
const { TextArea } = Input;
const CheckboxGroup = Checkbox.Group;

const UP_ARROW = '\u2191';
const uncheckToursText = "The Tours deselected will be Unapproved once request is submitted and the Tours will be removed from TimeKeeper";
const unapproveTourInTK = "By unapproving this tour, you are removing it from TK";
const contactInfoText = "The contract info in some Tour(s) don't match its Assignment/Service. Do you want to continue with approval?";
const tourUnapprovalReason = "Please provide the reason for the Tour reversal:";
const assignmentUnapprovalReason = "Please provide the reason for the Assignment reversal:";
const yellow = 'rgba(255, 255, 0, 0.25)';
const grey = 'rgba(215, 215, 215, 0.25)';

class ApprovalView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitting: false,
      shouldSubmit: false,
      isLoading: false,
      backRedirect: '',
      approvals: [],
      allToursCheckbox: false,
      allAssignmentsCheckbox: false,
      allCheckbox: false,
      tourCheckList: [],
      tourCheckMasterList: [],
      tourDirtyList: [],
      filteredTourDirtyList: [],
      toursNeedingReversals: [],
      tourReason: '',
      assignmentCheckList: [],
      assignmentCheckMasterList: [],
      assignmentDirtyList: [],
      filteredAssignmentDirtyList: [],
      assignmentReason: '',
      validation: [],
    }
  }

  componentDidMount = async () => {
    this.customBrowserBackNavigation();
    this.setUpLists();
  }

  customBrowserBackNavigation = () => {
    // event handler for browser back button
    // Note: only works when AppRouter component wraps Switch w/ HashRouter
    window.onpopstate = () => {
      const { pathname } = this.props.history.location;
      console.log(pathname)
      if (pathname === '/approvals') {
        this.setState({
          backRedirect: '/live-schedule-view-short'
        });
      }
    }
  }

  setUpLists = () => {

    let tourCheckList = [];
    let tourCheckMasterList = [];
    let tourDirtyList = [];
    let assignmentCheckList = [];
    let assignmentCheckMasterList = [];
    let assignmentDirtyList = [];

    // this sets up the information for the checkboxes to use, as well as the basic structure for tracking "dirty" checkboxes 
    this.props.approvals.forEach((approval, index) => {
      const tourValue = approval.tourId;
      if (!!approval.reconciled) { // if approved, add to list so checkbox is already checked
        tourCheckList.push(tourValue);
      }
      tourCheckMasterList.push(tourValue);
      // this array handles what we have changed, and therefor need to send as part of the submit
      tourDirtyList.push({
        tourId: tourValue,
        rdtId: approval.rdtId,
        initialApprovalValue: !!approval.reconciled,
        currentApprovalValue: !!approval.reconciled,
        dirty: false
      });

      if (approval.serviceOrders && approval.serviceOrders.length > 0) {
        approval.serviceOrders.forEach((assignment, index) => {
          if (assignment.statusInt !== 10) { // make sure its not a standby assignment
            const assignmentValue = assignment.serviceId;
            if (!!assignment.approved) {
              assignmentCheckList.push(assignmentValue);
            }
            assignmentCheckMasterList.push(assignmentValue);
            // this array handles what we have changed, and therefor need to send as part of the submit
            assignmentDirtyList.push({
              jeId: assignmentValue,
              initialApprovalValue: !!assignment.approved,
              currentApprovalValue: !!assignment.approved,
              dirty: false
            });
          }
        })
      }
    });

    this.setState({
      approvals: this.props.approvals,
      tourCheckList,
      tourCheckMasterList,
      tourDirtyList,
      assignmentCheckList,
      assignmentCheckMasterList,
      assignmentDirtyList
    });
  }

  readyApiCall = () => {
    this.setState({
      isLoading: true
    });
    const params = cloneDeep(this.props.approvalParameters)
    if (params) {
      this.getDataFromApi(params);
    }
  }

  getDataFromApi = async (parameters) => {
    await this.props.actions.fetchTourApprovals(parameters);
    this.setUpLists();
    this.setState({
      isLoading: false
    });
  }

  handleApplyToToursClick = (event) => {
    if (!event.target.checked) {
      let text = {
        title: uncheckToursText
      };
      Understood('uncheckAllTours', text, this.handleUnderstoodDialogue)
    }

    let tourDirtyListCopy = cloneDeep(this.state.tourDirtyList);

    for (let tour of tourDirtyListCopy) {
      tour.currentApprovalValue = event.target.checked;
      tour.dirty = tour.currentApprovalValue === tour.initialApprovalValue ? false : true;
    }

    this.setState({
      allToursCheckbox: event.target.checked,
      tourCheckList: event.target.checked ? [...this.state.tourCheckMasterList] : [],
      tourDirtyList: tourDirtyListCopy
    });
  }

  handleApplyToAssigmentsClick = (event) => {

    let assignmentDirtyListCopy = cloneDeep(this.state.assignmentDirtyList);

    for (let assignment of assignmentDirtyListCopy) {
      assignment.currentApprovalValue = event.target.checked;
      assignment.dirty = assignment.currentApprovalValue === assignment.initialApprovalValue ? false : true;
    }

    this.setState({
      allAssignmentsCheckbox: event.target.checked,
      assignmentCheckList: event.target.checked ? [...this.state.assignmentCheckMasterList] : [],
      assignmentDirtyList: assignmentDirtyListCopy
    });
  }

  handleApplyToAll = (event) => {
    if (!event.target.checked) {
      let text = {
        title: uncheckToursText
      };
      Understood('uncheckAll', text, this.handleUnderstoodDialogue)
    }

    let assignmentDirtyListCopy = cloneDeep(this.state.assignmentDirtyList);
    let tourDirtyListCopy = cloneDeep(this.state.tourDirtyList);

    for (let tour of tourDirtyListCopy) {
      tour.currentApprovalValue = event.target.checked;
      tour.dirty = tour.currentApprovalValue === tour.initialApprovalValue ? false : true;
    }

    for (let assignment of assignmentDirtyListCopy) {
      assignment.currentApprovalValue = event.target.checked;
      assignment.dirty = assignment.currentApprovalValue === assignment.initialApprovalValue ? false : true;
    }

    this.setState({
      allCheckbox: event.target.checked,
      tourCheckList: event.target.checked ? [...this.state.tourCheckMasterList] : [],
      assignmentCheckList: event.target.checked ? [...this.state.assignmentCheckMasterList] : [],
      tourDirtyList: tourDirtyListCopy,
      assignmentDirtyList: assignmentDirtyListCopy,
    });
  }

  handleTourClick = (checkboxGroupList, value) => {

    const isTourIdEqualToValue = (tour) => tour.tourId === value;
    const indexInDirtyArray = this.state.tourDirtyList.findIndex(isTourIdEqualToValue);

    let tourCheckListCopy = [...this.state.tourCheckList];
    let tourDirtyListCopy = cloneDeep(this.state.tourDirtyList);

    if (checkboxGroupList.length === 0) {
      let text = {
        title: uncheckToursText
      };
      Understood('uncheckTour', text, this.handleUnderstoodDialogue);
      tourCheckListCopy = tourCheckListCopy.filter((arrayValue) => value !== arrayValue);
      tourDirtyListCopy[indexInDirtyArray].currentApprovalValue = false;
      tourDirtyListCopy[indexInDirtyArray].dirty =
        tourDirtyListCopy[indexInDirtyArray].currentApprovalValue === tourDirtyListCopy[indexInDirtyArray].initialApprovalValue ? false : true;
    } else {
      // might need to put a check to see if value is already in array
      tourCheckListCopy.push(value);
      tourDirtyListCopy[indexInDirtyArray].currentApprovalValue = true;
      tourDirtyListCopy[indexInDirtyArray].dirty =
        tourDirtyListCopy[indexInDirtyArray].currentApprovalValue === tourDirtyListCopy[indexInDirtyArray].initialApprovalValue ? false : true;
    }

    this.setState({
      tourCheckList: tourCheckListCopy,
      tourDirtyList: tourDirtyListCopy,
    });
  }

  handleAssignmentClick = (checkboxGroupList, value) => {
    const isAssignmentIdEqualToValue = (assignment) => assignment.jeId === value;
    const indexInDirtyArray = this.state.assignmentDirtyList.findIndex(isAssignmentIdEqualToValue);

    let assignmentCheckListCopy = [...this.state.assignmentCheckList];
    let assignmentDirtyListCopy = cloneDeep(this.state.assignmentDirtyList);

    if (checkboxGroupList.length === 0) {
      assignmentCheckListCopy = assignmentCheckListCopy.filter((arrayValue) => value !== arrayValue);
      assignmentDirtyListCopy[indexInDirtyArray].currentApprovalValue = false;
      assignmentDirtyListCopy[indexInDirtyArray].dirty =
        assignmentDirtyListCopy[indexInDirtyArray].currentApprovalValue === assignmentDirtyListCopy[indexInDirtyArray].initialApprovalValue ? false : true;
    } else {
      // might need to put a check to see if value is already in array
      assignmentCheckListCopy.push(value);
      assignmentDirtyListCopy[indexInDirtyArray].currentApprovalValue = true;
      assignmentDirtyListCopy[indexInDirtyArray].dirty =
        assignmentDirtyListCopy[indexInDirtyArray].currentApprovalValue === assignmentDirtyListCopy[indexInDirtyArray].initialApprovalValue ? false : true;
    }

    this.setState({
      assignmentCheckList: assignmentCheckListCopy,
      assignmentDirtyList: assignmentDirtyListCopy,
    });
  }

  handleUnderstoodDialogue = (key) => {
    let validationCopy = cloneDeep(this.state.validation);
    if (key === 'checkToursForReversals') {
      validationCopy = validationCopy.filter(validationKey => validationKey !== key);
      this.setState(() => ({
        validation: validationCopy
      }), () => {
        let payload = {
          title: tourUnapprovalReason,
          content: (<TextArea onChange={e => { this.tourReasonOnChange(e) }} />)
        }
        Reason('tourReason', payload, this.handleReasonDialogue);
      });
      return;
    }

    // this is a error, and if appears should cancel the in progress submission
    if (key === 'checkToursForDirectBilling') {
      validationCopy = validationCopy.filter(validationKey => validationKey !== key);
      this.setState(() => ({
        validation: validationCopy
      }), () => {
        this.resestStateForSubmit();
      });
      return;
    }
  }

  handleConfirmDialogue = (key, value) => {
    let validationCopy = cloneDeep(this.state.validation);
    if (key === 'checkAssignmentContactDetails') {
      if (value) {
        validationCopy = validationCopy.filter(validationKey => validationKey !== key);
        this.setState(() => ({
          validation: validationCopy
        }), () => {
          this.submit();
        });
        return;
      }
      this.resestStateForSubmit();
      return;
    }
  }

  handleReasonDialogue = async (key, value, content) => {
    let validationCopy = cloneDeep(this.state.validation);
    if (key === 'tourReason') {
      if (value) {

        const toursNeedingReversalsCopy = cloneDeep(this.state.toursNeedingReversals);
        validationCopy = validationCopy.filter(validationKey => validationKey !== key);
        this.setState(() => ({
          validation: validationCopy
        }));

        let parameters = {
          reversalReason: this.state.tourReason,
          approverId: this.props.user.login.id
        }
        let notification = { type: 'success', message: 'Creating reversal success' };

        for (let tour of toursNeedingReversalsCopy) {
          parameters.idFeed = tour.tourId;

          try {
            await this.props.actions.addTourReversal(parameters)

          } catch (error) {
            if (!isEmpty(error)) {
              console.error(error);
              notification = {
                type: 'error',
                message: "Creating reversal failed",
                description: error.errors[0].message.includes('->') ? error.errors[0].message.split('->')[1] : error.errors[0].message
              };
            }
          }

          Toast(notification);
          this.submit();
        }
        return;
      }
      return;
    }
    if (key === 'assignmentReason') {
      if (value) {
        if (this.state.assignmentReason.length > 0) {
          validationCopy = validationCopy.filter(validationKey => validationKey !== key);
          this.setState(() => ({
            validation: validationCopy
          }), () => {
            this.submit();
          });
          return;
        }
        else {
          message.config({
            top: 60,
          });
          message.error('You have to provide an unapproval reason.');
          this.validateSubmission();
        }
      }

      this.setState({
        isSubmitting: false,
        assignmentUnapprovalReason: '',
      });

      return;
    }
  }

  tourReasonOnChange = (event) => {
    this.setState({
      tourReason: event.target.value || ''
    })
  }

  assignmentReasonOnChange = (event) => {
    this.setState({
      assignmentReason: event.target.value || ''
    })
  }

  handleSubmit = async () => {
    let tourDirtyListCopy = cloneDeep(this.state.tourDirtyList);
    let assignmentDirtyListCopy = cloneDeep(this.state.assignmentDirtyList);

    tourDirtyListCopy = tourDirtyListCopy.filter(tour => tour.dirty === true);
    assignmentDirtyListCopy = assignmentDirtyListCopy.filter(assignment => assignment.dirty === true);

    this.setState({
      isSubmitting: true,
      validation: [],
      filteredTourDirtyList: tourDirtyListCopy,
      filteredAssignmentDirtyList: assignmentDirtyListCopy
    }, async () => {
      // validation is stored in state because of the async nature of the confirm dialogue
      await this.validateSubmission();
    });
  }

  validateSubmission = async () => {
    //check if tours need reversals or have direct billing set up
    let toursNeedingReversals = [];
    let toursThatAreDirectBilling = [];
    let assignmentContactInfoIssue = [];

    //validate tours
    for (let tour of this.state.filteredTourDirtyList) {

      let tourReversal;
      if (!tour.currentApprovalValue) {
        tourReversal = await this.checkTourReversals(tour);
      }

      let tourDirectBilling = await this.checkTourDirectBilling(tour);
      let contactInfo = await this.checkContactInfo(tour);

      if (tourReversal) {
        if (tourReversal === 'error') {
          this.resestStateForSubmit();
          return;
        } else {
          toursNeedingReversals.push(tourReversal);
        }
      }

      if (tourDirectBilling) {
        if (tourDirectBilling === 'error') {
          this.resestStateForSubmit();
          return;
        } else {
          toursThatAreDirectBilling.push(tourDirectBilling);
        }
      }

      if (contactInfo) {
        if (tourDirectBilling === 'error') {
          this.resestStateForSubmit();
          return;
        } else {
          assignmentContactInfoIssue.push(contactInfo);
        }
      }
    }

    if (toursNeedingReversals.length > 0) {
      await this.setState(() => ({
        validation: [...this.state.validation, 'checkToursForReversals'],
        toursNeedingReversals
      }));
      Understood('checkToursForReversals', { title: unapproveTourInTK }, this.handleUnderstoodDialogue)
    }

    if (toursThatAreDirectBilling.length > 0) {
      await this.setState(() => ({
        validation: [...this.state.validation, 'checkToursForDirectBilling']
      }));
      Understood('checkToursForDirectBilling', { title: toursThatAreDirectBilling.join(' ') }, this.handleUnderstoodDialogue)
    }

    if (assignmentContactInfoIssue.length > 0) {
      await this.setState(() => ({
        validation: [...this.state.validation, 'checkAssignmentContactDetails']
      }))
      Confirm('checkAssignmentContactDetails', { title: contactInfoText }, this.handleConfirmDialogue)
    }

    let needAssignmentUnapprovalReason = false;
    for (let assignment of this.state.filteredAssignmentDirtyList) {
      if (!assignment.currentApprovalValue) {
        needAssignmentUnapprovalReason = true;
      }
    }

    if (needAssignmentUnapprovalReason) {
      await this.setState(() => ({
        validation: [...this.state.validation, 'assignmentReason']
      }))

      let payload = {
        title: assignmentUnapprovalReason,
        content: (<TextArea onChange={e => { this.assignmentReasonOnChange(e) }} />)
      }
      Reason('assignmentReason', payload, this.handleReasonDialogue);
    }

    if (this.state.validation.length === 0) {
      this.submit();
    }
  }

  submit = async () => {
    if (this.state.validation.length > 0) {
      // this.resestStateForSubmit();
      return;
    }

    const parameters = this.composeParametersForApproval();

    let notification = { type: 'success', message: 'Submitting Approvals success' };

    try {
      await this.props.actions.updateTourApprovals(parameters);

      this.resestStateForSubmit();

      this.readyApiCall();
    }
    catch (error) {
      if (!isEmpty(error)) {
        notification = {
          type: 'error',
          message: "Submitting Approvals failed",
          description: error.errors[0].message.includes('->') ? error.errors[0].message.split('->')[1] : error.errors[0].message
        };
      }
    }
    Toast(notification);
    this.resestStateForSubmit();
  }

  checkTourReversals = async (tour) => {
    let parameters = {
      ids: tour.rdtId
    }

    let hasError;
    await this.props.actions.timeKeeperReversalCheckForTour(parameters).catch(error => {
      console.log("Loading check for Time Keeper reversal for tour fail\n" + JSON.stringify(error));
      hasError = true;
      let notification = {
        type: 'error',
        message: "Submitting Approvals failed",
        description: error.errors[0].message.includes('->') ? error.errors[0].message.split('->')[1] : error.errors[0].message
      };
      Toast(notification);
    });

    if (hasError) {
      return 'error';
    }

    if (this.props.timeKeeperReversalCheck) {
      return tour;
    }
  }

  checkTourDirectBilling = async (tour) => {
    let parameters = {
      tourId: tour.tourId
    }

    let hasError;
    await this.props.actions.tourIsDirectBillingCheckForTour(parameters).catch(error => {
      hasError = true;
      console.log("Loading check for direct billing for tour fail\n" + JSON.stringify(error));

      let notification = {
        type: 'error',
        message: "Submitting Approvals failed",
        description: error.errors[0].message.includes('->') ? error.errors[0].message.split('->')[1] : error.errors[0].message
      };
      Toast(notification);
    });

    if (hasError) {
      return 'error';
    }

    if (this.props.tourIsDirectBilling !== "OK") {
      return this.props.tourIsDirectBilling;
    }
  }

  checkContactInfo = async (tour) => {
    let parameters = {
      tourId: tour.tourId
    }

    let hasError;
    await this.props.actions.contactInfoByTourId(parameters).catch(error => {
      hasError = true;
      console.log("Loading check for direct billing for tour fail\n" + JSON.stringify(error));

      let notification = {
        type: 'error',
        message: "Submitting Approvals failed",
        description: error.errors[0].message.includes('->') ? error.errors[0].message.split('->')[1] : error.errors[0].message
      };
      Toast(notification);
    });

    if (hasError) {
      return 'error';
    }

    if (this.props.contactInfoForAssignment) {
      return this.props.contactInfoForAssignment;
    }
  }

  //uses the dirty lists to compose the the params for the submit
  composeParametersForApproval = () => {
    const tours = this.state.filteredTourDirtyList;
    const assignments = this.state.filteredAssignmentDirtyList;

    let parameters = {
      tours: '',
      tours2: '',
      values: '', //tourActions, example: '101'
      jeIds: '',
      jeIds2: '',
      whatToDo: '', //jesActions, example: '212'
      userId: this.props.user.login.id,
      location: 5,
      unapprovedReason: cloneDeep(this.state.assignmentReason)
    }

    let toursString = '';
    let tourActions = '';
    for (let tour of tours) {
      toursString += tour.tourId + ',';
      tourActions += tour.currentApprovalValue === true ? '1' : '0';
    }
    toursString = toursString.substring(0, toursString.length - 1);
    parameters.tours = toursString;
    parameters.values = tourActions;

    let assignmentsString = '';
    let assignmentActions = '';
    for (let assignment of assignments) {
      assignmentsString += assignment.jeId + ',';
      assignmentActions += assignment.currentApprovalValue === true ? '1' : '2';
    }

    assignmentsString = assignmentsString.substring(0, assignmentsString.length - 1);
    parameters.jeIds = assignmentsString;
    parameters.whatToDo = assignmentActions;

    return parameters;
  }

  // called to allow the user to submit again if the submission succeeds or fails
  resestStateForSubmit = () => {
    this.setState({
      isSubmitting: false,
      validation: [],
      tourUnapprovalReason: '',
      assignmentUnapprovalReason: '',
      filteredTourDirtyList: [],
      filteredAssignmentDirtyList: [],
    });
  }

  formatPayTransactions = (payTransactions) => {
    let fromattedPayTransactionString = '';
    for (let payTransaction of payTransactions) {
      fromattedPayTransactionString += (payTransaction.payTransaction + ', ');
    }
    return fromattedPayTransactionString.substring(0, fromattedPayTransactionString.length - 2);
  }

  formatIndicators = (indicators) => {
    let fromattedIndicatorsString = '';
    for (let indicator of indicators) {
      fromattedIndicatorsString += (indicator.indicator + ', ');
    }
    return fromattedIndicatorsString.substring(0, fromattedIndicatorsString.length - 2);
  }

  filterOutDummyComment = (comment) => {
    switch (comment) {
      case '&nbsp;':
        return ''
      default:
        return comment;
    }
  }

  addTourCheckbox = (approval) => {
    const value = approval.tourId;

    return (
      <CheckboxGroup
        value={this.state.tourCheckList}
        onChange={(checkboxGroupList) => {
          this.handleTourClick(checkboxGroupList, value)
        }}
      >
        <Checkbox
          value={value}
          style={{
            marginBottom: 15
          }}
        >Approve Tour</Checkbox>
      </CheckboxGroup>
    )
  }

  addAssignmentCheckbox = (assignment) => {
    const value = assignment.serviceId;

    //if there is a standby assignment we don't render the checkbox
    if (assignment.statusInt === 10) {
      return;
    }

    return (
      <CheckboxGroup
        value={this.state.assignmentCheckList}
        onChange={(checkboxGroupList) => {
          this.handleAssignmentClick(checkboxGroupList, value)
        }}
      >
        <Checkbox
          value={value}
          style={{
            marginBottom: 15
          }}
        >Approve Assignment</Checkbox>
      </CheckboxGroup>
    )
  }

  setBackgroundColor = (dayType) => {
    if (dayType && dayType.serviceId) {
      return dayType.statusInt === 10 ? { backgroundColor: yellow } : {};
    }

    if (dayType && dayType.rdtId) {
      return dayType.reconciled ? { backgroundColor: grey } : {}
    }

    return {};
  }

  render() {
    if (this.state.backRedirect && !this.props.hamburgerMenu) {
      window.history.pushState(null, null, '#/live-schedule-view-short');
      return <Navigate to={this.state.backRedirect} />
    }
    return (
      <DashboardLayout>
        {!this.state.isLoading ?
          (
            <React.Fragment>
              <PageTitle title={'Approvals'} />
              {this.props.approvals.length > 0 ?
                (<Widget>

                  {AuthLogic.submitApprovals(this.props.user) && (
                    <Button
                      id='approval-submit'
                      onClick={this.handleSubmit}
                      loading={this.state.isSubmitting}
                      style={{ marginBottom: 20, display: 'block' }}
                    >Submit</Button>
                  )}

                  {AuthLogic.approveJobElements(this.props.user) && (
                    <Checkbox
                      onChange={this.handleApplyToAssigmentsClick}
                      defaultChecked={this.state.allAssignmentsCheckbox}
                      disabled={this.state.allCheckbox}
                      style={{ marginBottom: 20, marginLeft: 8, display: 'block' }}
                    >Apply to Assignments</Checkbox>
                  )}

                  {AuthLogic.approveTours(this.props.user) && (
                    <Checkbox
                      onChange={this.handleApplyToToursClick}
                      defaultChecked={this.state.allToursCheckbox}
                      disabled={this.state.allCheckbox}
                      style={{ marginBottom: 20, display: 'block' }}
                    >Apply to Tours</Checkbox>
                  )}

                  {AuthLogic.approveTours(this.props.user) && AuthLogic.approveJobElements && (
                    <Checkbox
                      onChange={this.handleApplyToAll}
                      defaultChecked={this.state.allCheckbox}
                      disabled={this.state.allToursCheckbox || this.state.allAssignmentsCheckbox}
                      style={{ marginBottom: 20, display: 'block' }}
                    >Apply to All</Checkbox>
                  )}

                  <Divider />

                  <React.Fragment>
                    {this.props.approvals.map((approval, index) => (
                      <React.Fragment>
                        <Title level={3}>{approval.name + ' - ' + moment(approval.dayStart).format('dddd, MMMM Do YYYY') || ""}</Title>
                        <Title level={4}>Tour</Title>
                        {
                          AuthLogic.approveTours(this.props.user) && (
                            <React.Fragment>
                              {this.addTourCheckbox(approval)}
                            </React.Fragment>
                          )
                        }
                        <div style={this.setBackgroundColor(approval)}>
                          < Descriptions size='small' style={{ marginBottom: 30 }} bordered >
                            <Descriptions.Item label="Name" span={3} >{approval.name || ""}</Descriptions.Item>
                            <Descriptions.Item label="SSO" span={3} >{approval.sso || ""}</Descriptions.Item>
                            <Descriptions.Item label="Day Type" span={3} >{approval.dayType || ""}</Descriptions.Item>
                            <Descriptions.Item label="Start Time" span={3} >{moment(approval.dayStart).format('MM/DD/YYYY hh:mmA') || ""}</Descriptions.Item>
                            <Descriptions.Item label="End Time" span={3} >{moment(approval.dayEnd).format('MM/DD/YYYY hh:mmA') || ""}</Descriptions.Item>
                            <Descriptions.Item label="Updating User" span={3} >{approval.updatingUserName || ""}</Descriptions.Item>
                            <Descriptions.Item label="Last Updated" span={3} >{moment(approval.updatingTimeStamp).format('MM/DD/YYYY hh:mmA') || ""}</Descriptions.Item>
                            {AuthLogic.viewTourSalaryLevel(this.props.user) && (
                              <Descriptions.Item label="Salary Level" span={3} >{approval.salaryLevel || ""}</Descriptions.Item>
                            )}
                            {AuthLogic.viewTourSalaryLevelUpgrade(this.props.user) && (
                              <Descriptions.Item label="Salary Upgrade" span={3} >{approval.jobSalaryUpgrade || ""}</Descriptions.Item>
                            )}
                            <Descriptions.Item label="Notification Comment" span={3} >{approval.notification || ""}</Descriptions.Item>
                            <Descriptions.Item label="Approver Comment" span={3} >{this.filterOutDummyComment(approval.approverComment) || ""}</Descriptions.Item>
                          </Descriptions>
                        </div>

                        {approval.meals && approval.meals.length > 0 && (
                          <React.Fragment>
                            <Title level={4}>Meals</Title>
                            <div style={this.setBackgroundColor(approval)}>
                              {approval.meals.map((meal, index) => (
                                <Descriptions size='small' style={{ marginBottom: 30 }} bordered >
                                  <Descriptions.Item label="Meal Start" span={3} >{moment(meal.mealStart).format('MM/DD/YYYY hh:mmA') || ""}</Descriptions.Item>
                                  <Descriptions.Item label="Meal End" span={3} >{moment(meal.mealEnd).format('MM/DD/YYYY hh:mmA') || ""}</Descriptions.Item>
                                </Descriptions>
                              ))}
                            </div>
                          </React.Fragment>
                        )}

                        {approval.payTransactions && approval.payTransactions.length > 0 && (
                          <React.Fragment>
                            <Title level={4}>Pay Transactions</Title>
                            <div style={this.setBackgroundColor(approval)}>
                              <Descriptions size='small' style={{ marginBottom: 30 }} bordered >
                                <Descriptions.Item label="Pay Transactions" span={3} >{this.formatPayTransactions(approval.payTransactions)}</Descriptions.Item>
                              </Descriptions>
                            </div>
                          </React.Fragment>
                        )}

                        {approval.indicators && approval.indicators.length > 0 && (
                          <React.Fragment>
                            <Title level={4}>Indicators</Title>
                            <div style={this.setBackgroundColor(approval)}>
                              <Descriptions size='small' style={{ marginBottom: 30 }} bordered >
                                <Descriptions.Item label="Indicators" span={3} >{this.formatIndicators(approval.indicators)}</Descriptions.Item>
                              </Descriptions>
                            </div>
                          </React.Fragment>

                        )}

                        {approval.serviceOrders && approval.serviceOrders.length > 0 && (
                          <React.Fragment>
                            <Title level={4}>Assignments</Title>
                            {approval.serviceOrders.map((serviceOrder, index) => (
                              <div style={this.setBackgroundColor(serviceOrder)}>
                                {AuthLogic.approveJobElements(this.props.user) && (
                                  <React.Fragment>
                                    {this.addAssignmentCheckbox(serviceOrder)}
                                  </React.Fragment>
                                )}
                                <Descriptions size='small' style={{ marginBottom: 30 }} bordered >
                                  <Descriptions.Item label="Service Name" span={3} >{serviceOrder.service}</Descriptions.Item>
                                  <Descriptions.Item label="Assignment Start" span={3} >{moment(serviceOrder.startActual).format('MM/DD/YYYY hh:mmA') || ""}</Descriptions.Item>
                                  <Descriptions.Item label="Assignment End" span={3} >{moment(serviceOrder.endActual).format('MM/DD/YYYY hh:mmA') || ""}</Descriptions.Item>
                                  <Descriptions.Item label="Status" span={3} >{serviceOrder.status}</Descriptions.Item>
                                  <Descriptions.Item label="Last Updating User" span={3} >{serviceOrder.userName}</Descriptions.Item>
                                  <Descriptions.Item label="Last Updated Date" span={3} >{moment(serviceOrder.updateDateTime).format('MM/DD/YYYY hh:mmA') || ""}</Descriptions.Item>
                                  {AuthLogic.viewAssignmentSalaryLevelAndUpgrade(this.props.user) && (
                                    <React.Fragment>
                                      {
                                        serviceOrder.upgrade ? (
                                          <React.Fragment>
                                            <Descriptions.Item label="Salary Level" span={3} >{UP_ARROW + serviceOrder.salaryLevel}</Descriptions.Item>

                                            {UP_ARROW}
                                          </React.Fragment>
                                        )
                                          :
                                          (
                                            <React.Fragment>
                                              <Descriptions.Item label="Salary Level" span={3} >{serviceOrder.salaryLevel}</Descriptions.Item>
                                            </React.Fragment>
                                          )
                                      }
                                    </React.Fragment>
                                  )}
                                  <Descriptions.Item label="Cost Object #" span={3} >{serviceOrder.costObjectNumber}</Descriptions.Item>
                                  <Descriptions.Item label="Cost Object Name & Type" span={3} >{serviceOrder.costObjectName + ' ' + serviceOrder.costObjectTypeName}</Descriptions.Item>
                                  <Descriptions.Item label="Request #" span={3} >{serviceOrder.jobNumber}</Descriptions.Item>
                                  {AuthLogic.viewActivityType(this.props.user) && (
                                    <Descriptions.Item label="Activity Type" span={3} >{serviceOrder.activityType}</Descriptions.Item>
                                  )}
                                  <Descriptions.Item label="Assignment Description" span={3} >{serviceOrder.description}</Descriptions.Item>
                                  <Descriptions.Item label="Approver Comment" span={3} >{this.filterOutDummyComment(serviceOrder.approverComment)}</Descriptions.Item>
                                </Descriptions>
                              </div>

                            ))}
                          </React.Fragment>
                        )}
                      </React.Fragment>
                    ))}
                  </React.Fragment>
                </Widget>)
                :
                (<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />)
              }
            </React.Fragment>
          )
          :
          (
            <React.Fragment>
              <Spinner />
            </React.Fragment>
          )
        }

      </DashboardLayout>
    )
  }
}

function mapStateToProps(state) {
  return {
    approvals: state.approvals.data,
    approvalParameters: state.approvalParameters,
    user: state.user,
    timeKeeperReversalCheck: state.timeKeeperCheckForTour.data,
    tourIsDirectBilling: state.tourIsDirectBilling.data,
    contactInfoForAssignment: state.contactInfoForAssignment.data,
    tourReversal: state.tourReversal.status,
    hamburgerMenu: state.navigation.hamburgerMenu,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      fetchTourApprovals: bindActionCreators(
        approvalActions.fetchTourApprovals,
        dispatch
      ),
      timeKeeperReversalCheckForTour: bindActionCreators(
        approvalActions.fetchTimeKeeperReversalsByResourceDayTypeId,
        dispatch
      ),
      tourIsDirectBillingCheckForTour: bindActionCreators(
        approvalActions.fetchTourIsDirectBillingCheckByTourId,
        dispatch
      ),
      contactInfoByTourId: bindActionCreators(
        approvalActions.fetchContactInfoByTourId,
        dispatch
      ),
      addTourReversal: bindActionCreators(
        approvalActions.addTourReversal,
        dispatch
      ),
      updateTourApprovals: bindActionCreators(
        approvalActions.updateTourApprovals,
        dispatch
      )
    }
  };
}

export const withRouter = (Component) => {
	const Wrapper = (props) => {
		const history = useNavigate();
		return <Component history={history} {...props} />;
	};
	return Wrapper;
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(ApprovalView));
